export const DEFAULT_UTM_SOURCE = "directo";
export const DEFAULT_UTM_MEDIUM = "landing_consultas";

export const WHATSAPP_PHONES = {
  ford: "5493513527817",
  fiat: "5493513525903",
  peugeot: "5493513793585",
  jeep: "5493513743833",
  hyundai: "5493517385093",
  gac: "5493517915736",
};

const BRAND_KEYS = {
  FORD: "ford",
  FIAT: "fiat",
  PEUGEOT: "peugeot",
  JEEP: "jeep",
  HYUNDAI: "hyundai",
  GAC: "gac",
};

export const hasUtmInCurrentUrl = () => {
  const query = new URLSearchParams(window.location.search);
  return !!(query.get("utm_source") || query.get("utm_medium") || query.get("utm_campaign"));
};

const getStoredUtm = (key) => {
  const query = new URLSearchParams(window.location.search);
  return query.get(key) || sessionStorage.getItem(key) || null;
};

export const normalizeBrandKey = (brand) => {
  if (!brand) return null;
  const upper = String(brand).toUpperCase().trim();
  return BRAND_KEYS[upper] || String(brand).toLowerCase().trim();
};

/**
 * Resuelve UTMs: primero URL/sessionStorage, sino defaults.
 * utm_campaign: URL > marca del formulario (si se pasa brand).
 */
export const resolveUtmParams = (brand = null) => {
  const brandKey = normalizeBrandKey(brand);

  return {
    utm_source: getStoredUtm("utm_source") || DEFAULT_UTM_SOURCE,
    utm_medium: getStoredUtm("utm_medium") || DEFAULT_UTM_MEDIUM,
    utm_campaign: getStoredUtm("utm_campaign") || brandKey || null,
    utm_term: getStoredUtm("utm_term"),
    utm_content: getStoredUtm("utm_content"),
    utm_id: getStoredUtm("utm_id"),
    utm_brand: getStoredUtm("utm_brand"),
  };
};

export const getUtmParams = (brand = null) => resolveUtmParams(brand);

export const buildConsultasTrackingUrl = (utmParams) => {
  const trackingParams = new URLSearchParams();
  trackingParams.append("utm_source", utmParams.utm_source);
  trackingParams.append("utm_medium", utmParams.utm_medium);
  if (utmParams.utm_campaign) trackingParams.append("utm_campaign", utmParams.utm_campaign);
  if (utmParams.utm_content) trackingParams.append("utm_content", utmParams.utm_content);
  return `https://oficial.montironi.com/consultas/?${trackingParams.toString()}`;
};

export const buildWhatsAppSendUrl = (brandKey, utmParams) => {
  const resolved = utmParams || resolveUtmParams(brandKey);
  const phone = WHATSAPP_PHONES[brandKey] || WHATSAPP_PHONES.hyundai;
  const trackingUrl = buildConsultasTrackingUrl(resolved);
  const message = `Hola, me gustaría hacer una consulta.\n${trackingUrl}`;
  const params = new URLSearchParams({ phone, text: message });
  return `https://api.whatsapp.com/send?${params.toString()}`;
};

// Configuración de números de WhatsApp por UTM parameters
export const whatsappConfig = {
  default: {
    number: "+543516825130",
    message: "Hola Montironi!",
  },
};

export const getWhatsAppUrl = (utmParams = {}) => {
  const { utm_source, utm_campaign } = utmParams;

  if (utm_source === "tiktok" && utm_campaign) {
    const tiktokConfig = whatsappConfig.tiktok;
    const campaignConfig = tiktokConfig.campaigns[utm_campaign];

    if (campaignConfig) {
      const encodedMessage = encodeURIComponent(campaignConfig.message);
      return `https://api.whatsapp.com/send?phone=${campaignConfig.number}&text=${encodedMessage}`;
    }
  }

  if (utm_source === "tiktok") {
    const tiktokConfig = whatsappConfig.tiktok;
    const encodedMessage = encodeURIComponent(tiktokConfig.message);
    return `https://api.whatsapp.com/send?phone=${tiktokConfig.number}&text=${encodedMessage}`;
  }

  if (utm_source && whatsappConfig[utm_source]) {
    const config = whatsappConfig[utm_source];
    const encodedMessage = encodeURIComponent(config.message);
    return `https://api.whatsapp.com/send?phone=${config.number}&text=${encodedMessage}`;
  }

  const defaultConfig = whatsappConfig.default;
  const encodedMessage = encodeURIComponent(defaultConfig.message);
  return `https://api.whatsapp.com/send?phone=${defaultConfig.number}&text=${encodedMessage}`;
};

export const saveUtmParams = () => {
  const query = new URLSearchParams(window.location.search);
  if (query) {
    if (query.get("utm_source")) {
      sessionStorage.setItem("utm_source", query.get("utm_source"));
    }
    if (query.get("utm_medium")) {
      sessionStorage.setItem("utm_medium", query.get("utm_medium"));
    }
    if (query.get("utm_campaign")) {
      sessionStorage.setItem("utm_campaign", query.get("utm_campaign"));
    }
    if (query.get("utm_term")) {
      sessionStorage.setItem("utm_term", query.get("utm_term"));
    }
    if (query.get("utm_content")) {
      sessionStorage.setItem("utm_content", query.get("utm_content"));
    }
    if (query.get("utm_id")) {
      sessionStorage.setItem("utm_id", query.get("utm_id"));
    }
    if (query.get("utm_brand")) {
      sessionStorage.setItem("utm_brand", query.get("utm_brand"));
    }
  }
};
